import React from "react";
import { Typography, IconButton } from "@mui/material";
import { Print as PrintIcon } from "@mui/icons-material";
import { OrderData } from "../types/order";
import ThermalPrinterTest, { PrintData } from "src/printConfigration/PrintConfigration";

interface OrderHeaderProps {
  order: OrderData;
  outstandingAmount: number;
  onPrint: () => void;
  onGoBack: () => void;
  printData: PrintData
}

const OutstandingBalanceCard: React.FC<{ outstandingAmount: number }> = ({ outstandingAmount }) => {
  const hasOutstanding = outstandingAmount > 0;

  return (
    <div
      className={`px-4 py-2 min-w-[260px] flex items-center gap-2 rounded-lg shadow-md 
      ${hasOutstanding ? "bg-gradient-to-r from-red-100 to-red-200 border-2 border-red-500 shadow-red-200" : "bg-gradient-to-r from-green-100 to-green-200 border-2 border-green-500 shadow-green-200"
        }`}
    >
      <p className="font-bold tracking-wide text-gray-800 text-base">Outstanding Balance:</p>
      <p className={`font-bold text-lg ${hasOutstanding ? "text-red-600" : "text-green-600"}`}>{outstandingAmount || "0.00"} QAR</p>
    </div>
  );
};

const OrderHeader: React.FC<OrderHeaderProps> = ({ order, outstandingAmount, onPrint, printData }) => {
  // Determine the status to display
  const getDisplayStatus = () => {
    const remainingAmount = Number(order?.RemainingAmount) || 0;
    
    if (remainingAmount === 0) {
      return "Delivered";
    }
    
    return order.OrderStatus === "Confirm" ? "In Process" : order.OrderStatus;
  };

  const displayStatus = getDisplayStatus();
  
  const getStatusColor = () => {
    switch (displayStatus) {
      case "Delivered":
        return "bg-green-100 text-green-800";
      case "In Process":
        return "bg-blue-100 text-blue-800";
      case "Cancelled":
        return "bg-red-100 text-red-800";
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  return (
    <div className="flex flex-wrap justify-between items-start sm:items-center gap-4 mb-4">
      {/* Left Side */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 flex-1">
        {/* Order Title */}
        <Typography variant="h4" component="h1" className="font-bold tracking-wide min-w-[180px]">
          Order #{order.Orderid}
        </Typography>

        {/* Status + Balance */}
        <div className="flex items-center gap-4 flex-wrap">
          {/* Status Badge */}
          <div className={`px-3 py-1 rounded-full font-semibold text-base ${getStatusColor()}`}>
            {displayStatus}
          </div>

          {/* Outstanding Balance */}
          <OutstandingBalanceCard outstandingAmount={outstandingAmount} />
        </div>
      </div>

      {/* Right Side (Print Button) */}
      <ThermalPrinterTest PrintData={printData} BtnName="PRINT" icon={PrintIcon} />
    </div>
  );
};

export default OrderHeader;